import RichTextEditor from 'react-rte';

const RTEInput = ({name, value = RichTextEditor.createEmptyValue(), handleOnChange, index}) =>{
  let tempVal = value; 
  try{
    let temp = RichTextEditor.createValueFromString(value, 'html')
    const val = temp?._cache?.html?._cache?.html
    tempVal = RichTextEditor.createValueFromString(val, 'html')
  }catch{
    tempVal = value;
  }
    const toolbarConfig = {
        // Optionally specify the groups to display (displayed in the order listed).
        display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
        INLINE_STYLE_BUTTONS: [
          {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
          {label: 'Italic', style: 'ITALIC'},
          {label: 'Underline', style: 'UNDERLINE'}
        ],
        BLOCK_TYPE_DROPDOWN: [
          {label: 'Normal', style: 'unstyled'},
          {label: 'Heading Large', style: 'header-one'},
          {label: 'Heading Medium', style: 'header-two'},
          {label: 'Heading Small', style: 'header-three'}
        ],
        BLOCK_TYPE_BUTTONS: [
          {label: 'UL', style: 'unordered-list-item'},
          {label: 'OL', style: 'ordered-list-item'}
        ]
      };

    return  <RichTextEditor value={tempVal} toolbarConfig={toolbarConfig} onChange={(e)=>handleOnChange(e,name, index )} />
}

export default RTEInput